/** Пробельный символ — вынесен из функции, чтобы регулярка компилировалась один раз. */
const WHITESPACE = /\s/;

/**
 * Делает заглавной первую букву строки.
 *
 * Рассчитано на ввод: вызывается на каждое нажатие клавиши в полях наименований
 * (ФИО, названия товаров, услуг, задач), поэтому в самом частом случае — когда
 * менять нечего — не создаёт ни строк, ни массивов и возвращает исходное
 * значение как есть.
 *
 * Правила ровно такие:
 *
 * - меняется один символ. Остальную строку в нижний регистр не приводим, иначе
 *   «iPhone 15 Pro» превратился бы в «Iphone 15 pro», а «МКПП» — в «Мкпп»;
 * - ведущие пробелы пропускаются: заглавной становится первая буква, а не
 *   первый символ, — иначе случайный пробел или вставка из буфера с пробелом
 *   отключали бы поведение совсем;
 * - если первый непробельный символ не буква (цифра, кавычка, дефис), строка
 *   остаётся нетронутой: угадывать, где в «3м скотч» начинается слово, функция
 *   не берётся. Проверка выходит бесплатной — у не-букв верхний регистр
 *   совпадает с самим символом;
 * - работа идёт по код-поинтам, а не по единицам UTF-16, поэтому surrogate-пары
 *   не ломаются: эмодзи в начале названия остаётся целым;
 * - если в верхнем регистре символ занимает другое число символов (ß → SS),
 *   строка не меняется: иначе сдвинулась бы каретка и пользователь потерял бы
 *   позицию ввода.
 *
 * Взят `toUpperCase`, а не `toLocaleUpperCase`: в турецкой и азербайджанской
 * локали латинская `i` переходит в `İ`, и у части сотрудников ввод в русскую
 * CRM подменялся бы неожиданным символом.
 */
export const capitalizeFirstLetter = (value: string): string => {
    if (!value) return value;

    let index = 0;
    while (index < value.length && WHITESPACE.test(value[index])) index += 1;

    const codePoint = value.codePointAt(index);
    if (codePoint === undefined) return value;

    const firstLetter = String.fromCodePoint(codePoint);
    const upperCased = firstLetter.toUpperCase();

    // уже заглавная, не буква вовсе или регистр меняет длину — не трогаем
    if (upperCased === firstLetter || upperCased.length !== firstLetter.length) return value;

    return value.slice(0, index) + upperCased + value.slice(index + firstLetter.length);
};
